module.exports = __webpack_public_path__ + "img/location-home.a8764658.svg";